console.log('PurplePanda Ecom')
import { ScrollArea } from "//safe-shield.eu/cdn/shop/t/100/assets/theme.js?v=131725828461297591351792596134";

let DeliveryTimes = class extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.textContainer = this.querySelector("[data-text]");
      this.deliveryDays = parseInt(this.getAttribute("data-time"));
      this.dateString = this.getAttribute("data-string");
      this.currentLocate = this.getAttribute("data-locale");
      this.calcDate();
    }
  
    disconectedCallback() {}
  
    calcDate() {
      let today = new Date();
      let deliveryTime = this.deliveryDays;
      const germanTime = new Date(
        today.toLocaleString("en-US", { timeZone: "Europe/Berlin" })
      );
  
      // If current time in Germany is past 14:00, add one more day to delivery time
      if (germanTime.getHours() >= 14) {
        deliveryTime += 1;
      }
  
      // Calculate target delivery date, skipping weekends
      while (deliveryTime > 0) {
        today.setDate(today.getDate() + 1);
        const dayOfWeek = today.getDay();
        // If today is not Saturday (6) or Sunday (0), decrease deliveryTime
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          deliveryTime--;
        }
      }
  
      // Format the target date
      const options = { weekday: "long", day: "2-digit", month: "2-digit" };
      let targetDate = today.toLocaleDateString(this.currentLocate, options);
      targetDate = targetDate.replace("/", ".").replace("/", ".");
      this.textContainer.textContent = this.dateString.replace(
        "[date]",
        targetDate
      );
      this.removeAttribute("hidden");
    }
  };
  
  if (!window.customElements.get("delivery-time")) {
    window.customElements.define("delivery-time", DeliveryTimes);
  }



  class FreeItems extends HTMLElement {
    constructor() {
        super();
        //theme.Cart.functions.refreshCartAreas(null,this.getAttribute('data-section-id'));
        // Your custom element initialization code here
        let atcButtons = this.querySelectorAll('[data-add-to-cart]');
        this.init(atcButtons);
    }

      connectedCallback() {
        this.items = Array.from(this.children);
        new ScrollArea(this);
        this.addEventListener("control:prev", this._prev);
        this.addEventListener("control:next", this._next);
      }

      _prev() {
        this.scrollBy({ left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
      }
      _next() {
        this.scrollBy({ left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
      }

    init(atcButtons){
        atcButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              this.addButton(button.getAttribute('data-add-to-cart'))
            });
        })
            
    }

    addButton(id){
        const rootUrl = window.Shopify.routes.root;
        const apiUrl = rootUrl + 'cart/add.js';
        // Construct the request payload
        const payload = {
            items: [
                {
                    quantity: 1,
                    id: id,
                },
            ],
        };
    
        // Make a request to the Shopify public API
        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
        .then(response => response.json())
        .then(data => {
            // Handle the response
            console.log('Variant added to cart:', data);
            document.dispatchEvent(new Event("cart:refresh"));
            if (window.location.pathname.replace(/\/+$/, '') === (rootUrl + 'cart').replace(/\/+$/, '')) {
              window.location.reload();
            }

        })
        .catch(error => {
            console.error('Error adding variant to cart:', error);
        });
    }
}

// Register your custom element with the browser
customElements.define('free-items', FreeItems);

class UnitPrices extends HTMLElement {
  constructor() {
    super();
    this.data = JSON.parse(this.getAttribute('data-json'));
    this._currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });

  }

  connectedCallback() {
    this.init();
    document.addEventListener("variant:change", this.handleVariantChange.bind(this));
  }

  init() {
    let variantID = parseInt(this.getAttribute('data-variant-id'));
    this.changeVariant(variantID);
  }

  handleVariantChange(e) {
    let variantId = e.detail?.variant?.id;
    if(variantId){
      this.changeVariant(variantId);
    }
  }

  changeVariant(id) {
    let foundObject = this.data.find((item) => item.id === id);
    console.log(foundObject);
    if (!foundObject) {
      return;
    }

    const { price, savings, pieces } = foundObject;
    const discountedPrice = price * (1 - savings / 100);
    const pricePerPiece = discountedPrice / pieces;
    //const formatted = (Math.ceil(pricePerPiece) / 100).toFixed(2);

    let priceString = `${this._currencyFormatter.format(Math.ceil(pricePerPiece) / 100)}`;
    let pieceString = this.getAttribute('data-piece');

    this.innerText = `${priceString} / ${pieceString}`;
  }

}



customElements.define('unit-price-custom', UnitPrices);
